import React from 'react';
import { Modal } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import ControlliNonConformita from '../manualecomponents/dettaglio_procedura/ControlliNonConformita';
import ActionButton from '../../../components/ActionButton';

import PropTypes from 'prop-types';
import ParametriSection from './ParametriSection';
import TwoActionsAlertDialog from '../../../components/TwoActionsAlertDialog';
import { reportError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '6px',
    padding: '10px',
    boxShadow: theme.shadows[6],
    width: '90%',
    maxWidth: '1100px',
    height: '85%',
    minHeight: '420px',
    maxHeight: '620px',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  expandedModalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '6px',
    padding: '10px',
    boxShadow: theme.shadows[6],
    height: '85%',
    overflowY: 'auto',
    minHeight: '420px',
    maxHeight: '900px',
    width: '90%',
    maxWidth: '1100px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

/**
 * Comparable snapshot of the azioni correttive table, used to tell whether it
 * still matches what was loaded. Compared instead of latching a flag on the
 * first edit, so adding an azione correttiva and deleting it again counts as no
 * change. Array position carries the row order.
 */
const snapshotAzioni = (arrayTabella) => JSON.stringify(arrayTabella);

class ModalSelezioneLimiti extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      controlloConformita: this.props.controlloConformita || {},
      nuoviControlliNonConformita: this.props.controlliSemplificati
        ? this.props.controlloConformita?.controlliNonConformitaSemplificato ||
          null
        : this.props.controlloConformita?.nonConformita || [],
      expandedAccordion: false,
      arrayTabella: [],
      pristineAzioni: snapshotAzioni([]),
      isTwoActionsDialogOpen: false,
      temperaturaMinima: this.props.controlloConformita?.temperaturaMinima,
      temperaturaMassima: this.props.controlloConformita?.temperaturaMassima,
      temperaturaConsigliata:
        this.props.controlloConformita?.temperaturaConsigliata,
      valoreTPMMinimo: this.props.controlloConformita?.valoreTPMMinimo,
      valoreTPMMassimo: this.props.controlloConformita?.valoreTPMMassimo,
      valoreTPMConsigliato:
        this.props.controlloConformita?.valoreTPMConsigliato,
      valoreDecimaleMinimo:
        this.props.controlloConformita?.valoreDecimaleMinimo,
      valoreDecimaleMassimo:
        this.props.controlloConformita?.valoreDecimaleMassimo,
      valoreDecimaleConsigliato:
        this.props.controlloConformita?.valoreDecimaleConsigliato,
      valoreInteroMinimo: this.props.controlloConformita?.valoreInteroMinimo,
      valoreInteroMassimo: this.props.controlloConformita?.valoreInteroMassimo,
      valoreInteroConsigliato:
        this.props.controlloConformita?.valoreInteroConsigliato,
    };
  }

  hasUnsavedAzioni = () =>
    snapshotAzioni(this.state.arrayTabella) !== this.state.pristineAzioni;

  componentDidMount = () => {
    let repartiControllo = [];
    let reparti = this.props.reparti;
    const defaultReparto = reparti.find((r) => r.repartoDefault);
    if (defaultReparto) {
      repartiControllo.push(defaultReparto.id);
    }

    let tipologieStrumentazioni = this.props.tipologieStrumentazioni;
    let controlloConformita = this.state.controlloConformita;

    if (this.props.controlloConformita === null) {
      controlloConformita.proceduraHaccpId = this.props.proceduraId;
      controlloConformita.reparti = repartiControllo;

      this.setState({
        controlloConformita,
        tipologieStrumentazioni,
      });
    } else {
      const arrayTabella = !this.props.controlliSemplificati
        ? this.createTableRecords(
            this.props.controlloConformita.nonConformita || [],
          )
        : this.createTableRecords(
            this.props.controlloConformita.controlliNonConformitaSemplificato ||
              null,
          );
      let repartiIsNullOrEmpty =
        this.props.controlloConformita.reparti === null ||
        this.props.controlloConformita.reparti === undefined ||
        this.props.controlloConformita.reparti.length === 0;

      controlloConformita = {
        indice: this.props.controlloConformita.indice,
        id: this.props.controlloConformita.id,
        proceduraHaccpId: this.props.controlloConformita.proceduraHaccpId,
        descrizioneOsservabile:
          this.props.controlloConformita.descrizioneOsservabile !== null
            ? this.props.controlloConformita.descrizioneOsservabile
            : '',
        categoriaControllo:
          this.props.controlloConformita.categoriaControllo !== null
            ? this.props.controlloConformita.categoriaControllo
            : 'CONTROLLO_GENERICO',
        categoriaOsservabile:
          this.props.controlloConformita.categoriaOsservabile,
        tipologiaStrumentazioneId:
          this.props.controlloConformita.tipologiaStrumentazioneId === null
            ? -2
            : this.props.controlloConformita.tipologiaStrumentazioneId,
        cadenza:
          this.props.controlloConformita.cadenza === null
            ? 'ALTRO'
            : this.props.controlloConformita.cadenza,
        altraCadenza: this.props.controlloConformita.altraCadenza,
        limiti:
          this.props.controlloConformita.limiti === null
            ? ''
            : this.props.controlloConformita.limiti,
        bloccante:
          this.props.controlloConformita.bloccante === null
            ? false
            : this.props.controlloConformita.bloccante,
        periodico: this.props.controlloConformita.periodico,
        controlliNonConformita: [],
        cadenze:
          this.props.controlloConformita.cadenze === null ||
          this.props.controlloConformita.cadenze === undefined
            ? []
            : this.props.controlloConformita.cadenze,
        attrezzature:
          this.props.controlloConformita.attrezzature === null ||
          this.props.controlloConformita.attrezzature === undefined
            ? []
            : this.props.controlloConformita.attrezzature,
        reparti: repartiIsNullOrEmpty
          ? repartiControllo
          : this.props.controlloConformita.reparti,
        temperaturaMinima:
          this.props.controlloConformita.temperaturaMinima === null
            ? ''
            : this.props.controlloConformita.temperaturaMinima,
        temperaturaMassima:
          this.props.controlloConformita.temperaturaMassima === null
            ? ''
            : this.props.controlloConformita.temperaturaMassima,
        temperaturaConsigliata:
          this.props.controlloConformita.temperaturaConsigliata === null
            ? ''
            : this.props.controlloConformita.temperaturaConsigliata,
        valoreInteroMinimo:
          this.props.controlloConformita.valoreInteroMinimo === null
            ? ''
            : this.props.controlloConformita.valoreInteroMinimo,
        valoreInteroMassimo:
          this.props.controlloConformita.valoreInteroMassimo === null
            ? ''
            : this.props.controlloConformita.valoreInteroMassimo,
        valoreInteroConsigliato:
          this.props.controlloConformita.valoreInteroConsigliato === null
            ? ''
            : this.props.controlloConformita.valoreInteroConsigliato,
        valoreDecimaleMinimo:
          this.props.controlloConformita.valoreDecimaleMinimo === null
            ? ''
            : this.props.controlloConformita.valoreDecimaleMinimo,
        valoreDecimaleMassimo:
          this.props.controlloConformita.valoreDecimaleMassimo === null
            ? ''
            : this.props.controlloConformita.valoreDecimaleMassimo,
        valoreDecimaleConsigliato:
          this.props.controlloConformita.valoreDecimaleConsigliato === null
            ? ''
            : this.props.controlloConformita.valoreDecimaleConsigliato,
        categoriaPersonalizzataId:
          this.props.controlloConformita.categoriaPersonalizzataId || null,
        categoriaPersonalizzataNome:
          this.props.controlloConformita.categoriaPersonalizzataNome || null,
        categoriaPersonalizzataUnitaMisura:
          this.props.controlloConformita.categoriaPersonalizzataUnitaMisura ||
          null,
      };

      this.setState({
        controlloConformita,
        tipologieStrumentazioni,
        arrayTabella: arrayTabella,
        pristineAzioni: snapshotAzioni(arrayTabella),
      });
    }
  };

  handleAccordionChange = (event) => {
    const flag = !this.state.expandedAccordion;
    this.setState({
      expandedAccordion: flag,
    });
  };

  createTableRecords = (controlliNonConformita) => {
    if (this.props.controlliSemplificati) {
      let arrayTabella = [];
      if (
        controlliNonConformita &&
        controlliNonConformita.azioniCorrettive !== undefined &&
        controlliNonConformita.azioniCorrettive.length > 0
      ) {
        arrayTabella = controlliNonConformita.azioniCorrettive;
      }
      return arrayTabella;
    } else {
      let arrayTabella = [];
      if (controlliNonConformita.length > 0) {
        let controlloNonConf = {};
        for (let i = 0; i < controlliNonConformita.length; i++) {
          if (controlliNonConformita[i].controlliCause.length === 0) {
            controlloNonConf = {
              // Position in the nested structure. Ids are absent until the
              // backend has seen the row, so deletion works off these.
              // They only hold against the structure they were built from:
              // anything that changes nuoviControlliNonConformita has to
              // rebuild these rows, or a delete will hit the wrong one.
              controlloIndex: i,
              causaIndex: null,
              azioneIndex: null,
              id: controlliNonConformita[i].id,
              limite: controlliNonConformita[i].limite,
              limiteCausa: null,
              descrizioneAzione: null,
              siglaAzione: null,
            };
            arrayTabella.push(controlloNonConf);
          } else {
            let controllicause = controlliNonConformita[i].controlliCause;
            for (let j = 0; j < controllicause.length; j++) {
              if (controllicause[j].azioniCorrettive.length === 0) {
                controlloNonConf = {
                  controlloIndex: i,
                  causaIndex: j,
                  azioneIndex: null,
                  id: controlliNonConformita[i].id,
                  limite: controlliNonConformita[i].limite,
                  limiteCausa: controllicause[j].limite,
                  descrizioneAzione: null,
                  siglaAzione: null,
                };
                arrayTabella.push(controlloNonConf);
              } else {
                let azionicorrettive = controllicause[j].azioniCorrettive;
                for (let k = 0; k < azionicorrettive.length; k++) {
                  controlloNonConf = {
                    controlloIndex: i,
                    causaIndex: j,
                    azioneIndex: k,
                    id: controlliNonConformita[i].id,
                    limite: controlliNonConformita[i].limite,
                    limiteCausa: controllicause[j].limite,
                    descrizioneAzione: azionicorrettive[k].descrizione,
                    siglaAzione: azionicorrettive[k].sigla,
                  };
                  arrayTabella.push(controlloNonConf);
                }
              }
            }
          } //end else-if
        } //end loop on controlli non conformità
      } //end if

      return arrayTabella;
    }
  };

  onAggiungiButtonClickedSemplificato = (valueAzione, valueSigla) => {
    if (valueAzione !== '' && valueSigla !== '') {
      if (valueSigla.length <= 12) {
        let newAzioniArray = [...this.state.arrayTabella];
        let nuoviControlliNonConformita = {
          ...this.state.nuoviControlliNonConformita,
        };
        newAzioniArray.push({
          descrizione: valueAzione,
          sigla: valueSigla,
          id: null,
        });
        nuoviControlliNonConformita.azioniCorrettive = newAzioniArray;
        this.setState({
          arrayTabella: newAzioniArray,
          nuoviControlliNonConformita: nuoviControlliNonConformita,
        });
      } else {
        reportError('La sigla inserita ha più di 12 caratteri');
      }
    } else if (valueAzione !== '' && valueSigla === '') {
      let newAzioniArray = [...this.state.arrayTabella];
      let nuoviControlliNonConformita = {
        ...this.state.nuoviControlliNonConformita,
      };
      newAzioniArray.push({
        descrizione: valueAzione,
        sigla: null,
        id: null,
      });
      nuoviControlliNonConformita.azioniCorrettive = newAzioniArray;
      this.setState({
        arrayTabella: newAzioniArray,
        nuoviControlliNonConformita: nuoviControlliNonConformita,
      });
    } else if (valueAzione === '' && valueSigla !== '') {
      reportError(
        "La sigla inserita non ha un'azione correttiva specificata. Inserire una sigla alfanumerica di max 12 caratteri insieme all'azione correttiva.",
      );
    }
  };

  deleteControlloNonConformitaSemplificato = (index) => {
    let newAzioniArray = [...this.state.arrayTabella];
    let nuoviControlliNonConformita = {
      ...this.state.nuoviControlliNonConformita,
    };
    newAzioniArray.splice(index, 1);
    nuoviControlliNonConformita.azioniCorrettive = newAzioniArray;
    this.setState({
      arrayTabella: newAzioniArray,
      nuoviControlliNonConformita: nuoviControlliNonConformita,
    });
  };

  addControlloNonConformita = (nuovoControlloNonConformita) => {
    let arrayOfControlliNonConformita = [
      ...this.state.nuoviControlliNonConformita,
    ];
    arrayOfControlliNonConformita.push(nuovoControlloNonConformita);

    // Built by the same walker that runs on mount, so a row added here and a
    // row loaded from the backend carry the same fields and the same
    // positions - which is what makes deletion work before a save.
    this.setState({
      expandedAccordion: false,
      nuoviControlliNonConformita: arrayOfControlliNonConformita,
      arrayTabella: this.createTableRecords(arrayOfControlliNonConformita),
    });
  };

  // `record` is a whole arrayTabella row and carries its own position in the
  // nested structure, so the deepest level it names is the one removed. Ids
  // are not usable here: nothing added in this session has one until the
  // backend has seen it, and every id-less row would match every other.
  //
  // One row is one leaf path, so a level emptied by the deletion would render
  // as a row of its own and the clicked row would appear to survive. Emptied
  // ancestors are therefore removed too, which is what makes the row go away
  // and stay away once the modal is reopened.
  deleteControlloNonConformita = (record) => {
    const { controlloIndex, causaIndex, azioneIndex } = record;

    const controlli = this.state.nuoviControlliNonConformita
      .map((controllo, i) => {
        if (i !== controlloIndex) {
          return controllo;
        }
        if (!Number.isInteger(causaIndex)) {
          return null;
        }
        const controlliCause = controllo.controlliCause
          .map((causa, j) => {
            if (j !== causaIndex) {
              return causa;
            }
            if (!Number.isInteger(azioneIndex)) {
              return null;
            }
            const azioniCorrettive = causa.azioniCorrettive.filter(
              (_azione, k) => k !== azioneIndex,
            );
            return azioniCorrettive.length === 0
              ? null
              : { ...causa, azioniCorrettive };
          })
          .filter((causa) => causa !== null);

        return controlliCause.length === 0
          ? null
          : { ...controllo, controlliCause };
      })
      .filter((controllo) => controllo !== null);

    // Rebuilt rather than spliced, so every remaining row carries a position
    // that still matches the structure it was built from.
    this.setState({
      nuoviControlliNonConformita: controlli,
      arrayTabella: this.createTableRecords(controlli),
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    const regexTemperatura = /^-?\d*(\.?\d{0,1})$/;
    const regexTPM = /^(100(\.0?)?|(\d{0,2})(\.\d{0,1})?)$/;

    let validationRegex;
    if (name.includes('temperatura')) {
      validationRegex = regexTemperatura;
    } else if (name.includes('TPM')) {
      validationRegex = regexTPM;
    }

    if (validationRegex?.test(value) || value === '') {
      this.setState({
        [name]: value,
      });
    }
  };

  handleCustomLimitChange = (e) => {
    const { name, value } = e.target;

    const regexIntero = /^-?\d*$/; // numeri interi (positivi/negativi)
    const regexDecimale = /^-?\d*(\.\d{0,2})?$/; // numeri decimali con massimo 2 cifre decimali

    const isValid =
      value === '' ||
      (this.props.mode === 'INTERO' && regexIntero.test(value)) ||
      (this.props.mode === 'DECIMALE' && regexDecimale.test(value));

    if (isValid) {
      this.setState({
        [name]: value,
      });
    }
  };

  handleSave = async () => {
    const {
      mode,
      passLimiti,
      passLimitiTPM,
      passLimitiTemperatura,
      passLimitiOlioFriggitrice,
      passLimitiPersonalizzato,
    } = this.props;

    if (mode === 'TPM') {
      passLimitiTPM(
        this.state.nuoviControlliNonConformita,
        this.state.valoreTPMMinimo,
        this.state.valoreTPMMassimo,
        this.state.valoreTPMConsigliato,
      );
    } else if (mode === 'CONTROLLO_TEMPERATURE') {
      passLimitiTemperatura(
        this.state.nuoviControlliNonConformita,
        this.state.temperaturaMinima,
        this.state.temperaturaMassima,
        this.state.temperaturaConsigliata,
      );
    } else if (mode === 'OLIO_FRIGGITRICE') {
      passLimitiOlioFriggitrice(
        this.state.nuoviControlliNonConformita,
        this.state.valoreTPMMinimo,
        this.state.valoreTPMMassimo,
        this.state.temperaturaMinima,
        this.state.temperaturaMassima,
        this.state.temperaturaConsigliata,
      );
    } else if (mode === 'DECIMALE') {
      passLimitiPersonalizzato(
        this.state.nuoviControlliNonConformita,
        this.state.valoreDecimaleMinimo,
        this.state.valoreDecimaleMassimo,
        this.state.valoreDecimaleConsigliato,
        mode,
      );
    } else if (mode === 'INTERO') {
      passLimitiPersonalizzato(
        this.state.nuoviControlliNonConformita,
        this.state.valoreInteroMinimo,
        this.state.valoreInteroMassimo,
        this.state.valoreInteroConsigliato,
        mode,
      );
    } else {
      passLimiti(this.state.nuoviControlliNonConformita);
    }
  };

  render() {
    const { classes, open, onClose, mode } = this.props;

    return (
      <Modal
        open={open}
        onClose={() => {
          if (this.hasUnsavedAzioni()) {
            this.setState({
              isTwoActionsDialogOpen: true,
            });
          } else {
            this.props.onClose();
          }
        }}
        className={classes.modal}
      >
        <div
          className={
            this.state.expandedAccordion
              ? classes.expandedModalContainer
              : classes.modalContainer
          }
        >
          <ParametriSection
            mode={mode}
            state={this.state}
            controlloConformita={this.props.controlloConformita || {}}
            handleInputChange={this.handleInputChange}
            handleCustomLimitChange={this.handleCustomLimitChange}
          />
          <div style={{ overflowY: 'auto' }}>
            <ControlliNonConformita
              controlliNonConformita={this.state.arrayTabella}
              controlliSemplificati={this.props.controlliSemplificati}
              controlloConformitaId={this.state.controlloConformita.id}
              expandedAccordion={this.state.expandedAccordion}
              onChangeAccordion={this.handleAccordionChange}
              onAggiungiButtonClicked={this.addControlloNonConformita}
              onAggiungiButtonClickedSemplificato={
                this.onAggiungiButtonClickedSemplificato
              }
              onDeleteButtonClicked={this.deleteControlloNonConformita}
              onDeleteButtonClickedControlliSemplificato={
                this.deleteControlloNonConformitaSemplificato
              }
              mode={mode}
            />
          </div>
          <div className={classes.buttonWrapper}>
            <ActionButton
              label="Chiudi"
              secondaryButton
              onClick={() => {
                if (this.hasUnsavedAzioni()) {
                  this.setState({
                    isTwoActionsDialogOpen: true,
                  });
                } else {
                  this.props.onClose();
                }
              }}
            />
            <ActionButton label="Salva" onClick={this.handleSave} />
          </div>
          {this.state.isTwoActionsDialogOpen && (
            <TwoActionsAlertDialog
              visible={this.state.isTwoActionsDialogOpen}
              title="Attenzione"
              message="Ci sono delle modifiche sulle azioni correttive non salvate. Se si torna indietro, queste verranno perse. Procedere?"
              onOkClicked={() => {
                this.setState(
                  {
                    isTwoActionsDialogOpen: false,
                  },
                  () => {
                    onClose();
                  },
                );
              }}
              onIndietroClicked={() => {
                this.setState({
                  isTwoActionsDialogOpen: false,
                });
              }}
            />
          )}
        </div>
      </Modal>
    );
  }
}

ModalSelezioneLimiti.propTypes = {
  reparti: PropTypes.array,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  controlloConformita: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  passLimiti: PropTypes.func.isRequired,
  passLimitiTPM: PropTypes.func.isRequired,
  passLimitiTemperatura: PropTypes.func.isRequired,
  passLimitiOlioFriggitrice: PropTypes.func.isRequired,
  passLimitiPersonalizzato: PropTypes.func,
};

export default withStyles(styles)(ModalSelezioneLimiti);
